// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3ggxw","row":"ProcedureTreatmentSummary_row__1k9OS"};